function Nativications(){
    return (
        <>
        <div className="nativ">
            <div className="icon">
            <i className="fa-solid fa-circle-check"></i>
            </div>
            <div className="massage">
                <p>Your Cv has been updated</p>
            </div>
        </div>
        </>
    )
}
export default Nativications